// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-tabs-wrap .custom-tabs-box .custom-tab-btn {
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, transparent 0%, var(--platinum-400) 100%);
  box-shadow: none;
  color: var(--black-1000);
  text-transform: capitalize;
  z-index: 0;
  padding: 1rem 1.5rem;
  position: relative;
}
.custom-tabs-wrap .custom-tabs-box .custom-tab-btn::before {
  content: "";
  width: 100%;
  height: 100%;
  border-bottom: 3px solid var(--platinum-1000);
  border-radius: inherit;
  box-sizing: border-box;
  pointer-events: none;
  z-index: -1;
  position: absolute;
  inset: 0;
  transition: 200ms all ease-in-out;
}
.custom-tabs-wrap .custom-tabs-box .custom-tab-btn::after {
  content: "";
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, transparent 0%, var(--secondaryMain-400) 100%);
  border-bottom: 3px solid var(--secondaryMain-1000);
  border-radius: inherit;
  box-sizing: border-box;
  pointer-events: none;
  opacity: 0;
  z-index: -2;
  position: absolute;
  inset: 0;
  transition: 200ms all ease-in-out;
}
.custom-tabs-wrap .custom-tabs-box .custom-tab-btn.active {
  background: transparent;
}
.custom-tabs-wrap .custom-tabs-box .custom-tab-btn.active::before {
  border-bottom: 3px solid var(--secondaryMain-1000);
}
.custom-tabs-wrap .custom-tabs-box .custom-tab-btn.active::after {
  opacity: 1;
}
.custom-tabs-wrap .custom-tabs-box .embla {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.custom-tabs-wrap .custom-tabs-box .embla .embla__viewport {
  width: 100%;
  border-radius: 1rem;
  overflow: hidden;
}
.custom-tabs-wrap .custom-tabs-box .embla .embla__viewport .embla__container {
  display: flex;
}
.custom-tabs-wrap .custom-tabs-box .embla .embla__viewport .embla__container .embla__slide {
  min-width: 0;
  flex: 0 0 auto;
  padding: 0 0.5rem;
}
.custom-tabs-wrap .custom-tabs-box .embla .embla__button {
  width: 3.125rem;
  min-width: 3.125rem;
  height: 3.125rem;
  background-color: var(--primaryMain-1000);
  border: 0;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 200ms all ease-in-out;
}
.custom-tabs-wrap .custom-tabs-box .embla .embla__button svg {
  width: 1.25rem;
  height: 1.25rem;
  fill: var(--white-1000);
}
.custom-tabs-wrap .custom-tabs-box .embla .embla__button:hover:not(:disabled) {
  transform: scale(0.95);
}
.custom-tabs-wrap .custom-tabs-box .embla .embla__button:active:not(:disabled) {
  transform: scale(0.85);
}
.custom-tabs-wrap .custom-tabs-box .embla .embla__button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.custom-tabs-wrap .custom-tabs-content-box {
  filter: drop-shadow(0px 4px 4px var(--black-250));
  -webkit-filter: drop-shadow(0px 4px 4px var(--black-250));
  margin-top: 2.5rem;
  position: relative;
}
.custom-tabs-wrap .custom-tabs-content-box .animated-content-box {
  width: 100%;
  background-color: var(--white-1000);
  border-radius: 1.5rem;
  padding: 2.25rem;
  transform-origin: center;
}
@media screen and (max-width: 991.98px) {
  .custom-tabs-wrap .custom-tabs-box .custom-tab-btn {
    padding: 0.5rem 1rem;
  }
  .custom-tabs-wrap .custom-tabs-box .embla .embla__viewport {
    border-radius: 0.75rem;
  }
  .custom-tabs-wrap .custom-tabs-box .embla .embla__viewport .embla__container .embla__slide {
    padding: 0 0.5rem;
  }
  .custom-tabs-wrap .custom-tabs-box .embla .embla__button {
    width: 2rem;
    min-width: 2rem;
    height: 2rem;
  }
  .custom-tabs-wrap .custom-tabs-box .embla .embla__button svg {
    width: 0.75rem;
    height: 0.75rem;
  }
  .custom-tabs-wrap .custom-tabs-content-box {
    margin-top: 2rem;
  }
  .custom-tabs-wrap .custom-tabs-content-box .animated-content-box {
    border-radius: 1rem;
    padding: 1.25rem;
  }
}
@media screen and (max-width: 767.98px) {
  .custom-tabs-wrap .custom-tabs-box .custom-tab-btn {
    padding: 0.5rem 1rem;
  }
  .custom-tabs-wrap .custom-tabs-box .embla .embla__viewport {
    border-radius: 0.5rem;
  }
  .custom-tabs-wrap .custom-tabs-box .embla .embla__viewport .embla__container .embla__slide {
    padding: 0 0.25rem;
  }
  .custom-tabs-wrap .custom-tabs-box .embla .embla__button {
    width: 1.75rem;
    min-width: 1.75rem;
    height: 1.75rem;
  }
  .custom-tabs-wrap .custom-tabs-box .embla .embla__button svg {
    width: 0.625rem;
    height: 0.625rem;
  }
  .custom-tabs-wrap .custom-tabs-content-box {
    margin-top: 1.5rem;
  }
  .custom-tabs-wrap .custom-tabs-content-box .animated-content-box {
    padding: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common_UI_Kit/CustomTabs/CustomTabsStyle.scss"],"names":[],"mappings":"AAEI;EACE,WAAA;EACA,YAAA;EACA,6EAAA;EACA,gBAAA;EACA,wBAAA;EACA,0BAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;AADN;AAGM;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,6CAAA;EACA,sBAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,iCAAA;AADR;AAIM;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kFAAA;EACA,kDAAA;EACA,sBAAA;EACA,sBAAA;EACA,oBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,iCAAA;AAFR;AAKM;EACE,uBAAA;AAHR;AAKQ;EACE,kDAAA;AAHV;AAMQ;EACE,UAAA;AAJV;AASI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAPN;AAWM;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;AATR;AAWQ;EACE,aAAA;AATV;AAWU;EACE,YAAA;EACA,cAAA;EACA,iBAAA;AATZ;AAcM;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iCAAA;AAZR;AAcQ;EACE,cAAA;EACA,eAAA;EACA,uBAAA;AAZV;AAeQ;EACE,sBAAA;AAbV;AAgBQ;EACE,sBAAA;AAdV;AAiBQ;EACE,YAAA;EACA,mBAAA;AAfV;AAqBE;EACE,iDAAA;EACA,yDAAA;EACA,kBAAA;EACA,kBAAA;AAnBJ;AAqBI;EACE,WAAA;EACA,mCAAA;EACA,qBAAA;EACA,gBAAA;EACA,wBAAA;AAnBN;AAuBE;EAEI;IACE,oBAAA;EAtBN;EA0BM;IACE,sBAAA;EAxBR;EA2BU;IACE,iBAAA;EAzBZ;EA8BM;IACE,WAAA;IACA,eAAA;IACA,YAAA;EA5BR;EA8BQ;IACE,cAAA;IACA,eAAA;EA5BV;EAkCE;IACE,gBAAA;EAhCJ;EAkCI;IACE,mBAAA;IACA,gBAAA;EAhCN;AACF;AAoCE;EAEI;IACE,oBAAA;EAnCN;EAuCM;IACE,qBAAA;EArCR;EAwCU;IACE,kBAAA;EAtCZ;EA2CM;IACE,cAAA;IACA,kBAAA;IACA,eAAA;EAzCR;EA2CQ;IACE,eAAA;IACA,gBAAA;EAzCV;EA+CE;IACE,kBAAA;EA7CJ;EA+CI;IACE,aAAA;EA7CN;AACF","sourcesContent":[".custom-tabs-wrap {\n  .custom-tabs-box {\n    .custom-tab-btn {\n      width: 100%;\n      height: 100%;\n      background: linear-gradient(180deg, transparent 0%, var(--platinum-400) 100%);\n      box-shadow: none;\n      color: var(--black-1000);\n      text-transform: capitalize;\n      z-index: 0;\n      padding: 1rem 1.5rem;\n      position: relative;\n\n      &::before {\n        content: \"\";\n        width: 100%;\n        height: 100%;\n        border-bottom: 3px solid var(--platinum-1000);\n        border-radius: inherit;\n        box-sizing: border-box;\n        pointer-events: none;\n        z-index: -1;\n        position: absolute;\n        inset: 0;\n        transition: 200ms all ease-in-out;\n      }\n      \n      &::after {\n        content: \"\";\n        width: 100%;\n        height: 100%;\n        background: linear-gradient(180deg, transparent 0%, var(--secondaryMain-400) 100%);\n        border-bottom: 3px solid var(--secondaryMain-1000);\n        border-radius: inherit;\n        box-sizing: border-box;\n        pointer-events: none;\n        opacity: 0;\n        z-index: -2;\n        position: absolute;\n        inset: 0;\n        transition: 200ms all ease-in-out;\n      }\n\n      &.active {\n        background: transparent;\n\n        &::before {\n          border-bottom: 3px solid var(--secondaryMain-1000);\n        }\n        \n        &::after {\n          opacity: 1;\n        }\n      }\n    }\n\n    .embla {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      // filter: drop-shadow(0px 4px 4px var(--black-150));\n      // -webkit-filter: drop-shadow(0px 4px 4px var(--black-150));\n\n      .embla__viewport {\n        width: 100%;\n        border-radius: 1rem;\n        overflow: hidden;\n\n        .embla__container {\n          display: flex;\n\n          .embla__slide {\n            min-width: 0;\n            flex: 0 0 auto;\n            padding: 0 0.5rem;\n          }\n        }\n      }\n\n      .embla__button {\n        width: 3.125rem;\n        min-width: 3.125rem;\n        height: 3.125rem;\n        background-color: var(--primaryMain-1000);\n        border: 0;\n        border-radius: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n        transition: 200ms all ease-in-out;\n\n        svg {\n          width: 1.25rem;\n          height: 1.25rem;\n          fill: var(--white-1000);\n        }\n\n        &:hover:not(:disabled) {\n          transform: scale(0.95);\n        }\n\n        &:active:not(:disabled) {\n          transform: scale(0.85);\n        }\n\n        &:disabled {\n          opacity: 0.5;\n          cursor: not-allowed;\n        }\n      }\n    }\n  }\n\n  .custom-tabs-content-box {\n    filter: drop-shadow(0px 4px 4px var(--black-250));\n    -webkit-filter: drop-shadow(0px 4px 4px var(--black-250));\n    margin-top: 2.5rem;\n    position: relative;\n\n    .animated-content-box {\n      width: 100%;\n      background-color: var(--white-1000);\n      border-radius: 1.5rem;\n      padding: 2.25rem;\n      transform-origin: center;\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    .custom-tabs-box {\n      .custom-tab-btn {\n        padding: 0.5rem 1rem;\n      }\n\n      .embla {\n        .embla__viewport {\n          border-radius: 0.75rem;\n\n          .embla__container {\n            .embla__slide {\n              padding: 0 0.5rem;\n            }\n          }\n        }\n\n        .embla__button {\n          width: 2rem;\n          min-width: 2rem;\n          height: 2rem;\n      \n          svg {\n            width: 0.75rem;\n            height: 0.75rem;\n          }\n        }\n      }\n    }\n\n    .custom-tabs-content-box {\n      margin-top: 2rem;\n\n      .animated-content-box {\n        border-radius: 1rem;\n        padding: 1.25rem;\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    .custom-tabs-box {\n      .custom-tab-btn {\n        padding: 0.5rem 1rem;\n      }\n\n      .embla {\n        .embla__viewport {\n          border-radius: 0.5rem;\n          \n          .embla__container {\n            .embla__slide {\n              padding: 0 0.25rem;\n            }\n          }\n        }\n\n        .embla__button {\n          width: 1.75rem;\n          min-width: 1.75rem;\n          height: 1.75rem;\n      \n          svg {\n            width: 0.625rem;\n            height: 0.625rem;\n          }\n        }\n      }\n    }\n\n    .custom-tabs-content-box {\n      margin-top: 1.5rem;\n\n      .animated-content-box {\n        padding: 1rem;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
